import React from "react";
import { isMobile as isM } from "@shared/scripts/utils/tool";

import "../../sites/application/styles/_test_environment_banner.scss";

const TestEnvironmentBanner = ({ top = 0, zIndex = 100 }) => {
  const isMobile = isM();
  const currentHostname = window.location.hostname;

  const PRODUCTION_URL = "https://www.jiqizhixin.com/";
  const TEST_DOMAIN = "almosthuman.cn";
  const LOCAL_DOMAIN = "lvh.me";

  const isTestEnvironment =
    currentHostname.endsWith(TEST_DOMAIN) ||
    currentHostname === LOCAL_DOMAIN ||
    currentHostname.endsWith(`.${LOCAL_DOMAIN}`);

  if (!isTestEnvironment) {
    return null;
  }

  return (
    <div
      className={`test-environment-banner ${isMobile ? "is-mobile" : ""}`}
      style={{ top, zIndex }} // 动态注入
    >
      <div className="test-environment-banner__content">
        <span className="test-environment-banner__text">
          当前网站为测试功能用途，请勿在此进行产品支付。
        </span>
        <a
          href={PRODUCTION_URL}
          className="test-environment-banner__link"
          target="_blank"
          rel="noopener noreferrer"
        >
          点此前往正式网站→
        </a>
      </div>
    </div>
  );
};

export default TestEnvironmentBanner;
